import React from 'react';
import { formatMoney, formatDate } from './accountingConstants';
import ActionMenu from '../common/ActionMenu';
import { ZRODLA, skrocRachunek, formatujRachunek } from '../koszty/format';

export default function CostsTab({
  costs,
  costCategories,
  costsLoading,
  costsFilters,
  setCostsFilters,
  showCostModal,
  editingCost,
  costForm,
  setCostForm,
  locations,
  canManageSettlements,
  handleSaveCost,
  handlePayCost,
  handleDeleteCost,
  openEditCost,
  openNewCost,
  closeCostModal,
  fetchCosts
}) {
  return (
    <div>
      {/* Filtry i przycisk dodawania */}
      <div style={{
        backgroundColor: "var(--card-bg)",
        borderRadius: '6px',
        border: '1px solid var(--border)',
        padding: '0.75rem',
        marginBottom: '1rem',
        display: 'flex',
        gap: '0.5rem',
        flexWrap: 'wrap',
        alignItems: 'center'
      }}>
        <select
          value={costsFilters.category_id}
          onChange={(e) => setCostsFilters(f => ({...f, category_id: e.target.value}))}
          style={{ padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)', fontSize: '12px' }}
        >
          <option value="">Wszystkie kategorie</option>
          {costCategories.map(cat => (
            <option key={cat.id} value={cat.id}>{cat.nazwa}</option>
          ))}
        </select>
        <select
          value={costsFilters.status}
          onChange={(e) => setCostsFilters(f => ({...f, status: e.target.value}))}
          style={{ padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)', fontSize: '12px' }}
        >
          <option value="">Wszystkie statusy</option>
          <option value="niezaplacony">Do zapłaty</option>
          <option value="zaplacony">Zapłacone</option>
        </select>
        <input
          type="date"
          value={costsFilters.date_from}
          onChange={(e) => setCostsFilters(f => ({...f, date_from: e.target.value}))}
          style={{ padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)', fontSize: '12px' }}
        />
        <span style={{ fontSize: '12px', color: 'var(--text-muted)' }}>do</span>
        <input
          type="date"
          value={costsFilters.date_to}
          onChange={(e) => setCostsFilters(f => ({...f, date_to: e.target.value}))}
          style={{ padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)', fontSize: '12px' }}
        />
        <input
          type="text"
          data-testid="filtr-nip"
          placeholder="NIP kontrahenta"
          value={costsFilters.nip || ''}
          onChange={(e) => setCostsFilters(f => ({...f, nip: e.target.value}))}
          style={{ padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)', fontSize: '12px', width: '130px' }}
        />
        <select
          data-testid="filtr-zrodlo"
          value={costsFilters.zrodlo || ''}
          onChange={(e) => setCostsFilters(f => ({...f, zrodlo: e.target.value}))}
          style={{ padding: '6px 10px', border: '1px solid var(--border)', borderRadius: '6px', backgroundColor: 'var(--card-bg)', color: 'var(--text)', fontSize: '12px' }}
        >
          <option value="">Każde źródło</option>
          <option value="ksef">Z KSeF</option>
          <option value="reczny">Ręczne</option>
        </select>
        <button
          onClick={() => setCostsFilters({ category_id: '', status: '', date_from: '', date_to: '', nip: '', zrodlo: '' })}
          style={{ padding: '6px 12px', border: '1px solid var(--text-muted)', color: 'var(--text-muted)', fontSize: '12px' }}
        >
          Wyczyść
        </button>
        <button
          onClick={fetchCosts}
          style={{ padding: '6px 12px', border: '1px solid var(--info)', color: 'var(--info)', fontSize: '12px' }}
        >
          {'🔄'} Odśwież
        </button>
        {canManageSettlements && (
          <button
            onClick={openNewCost}
            style={{ marginLeft: 'auto', padding: '6px 12px', border: '1px solid var(--success)', color: 'var(--success)', fontSize: '12px' }}
          >
            + Dodaj koszt
          </button>
        )}
      </div>

      {/* Tabela kosztow */}
      {costsLoading ? (
        <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)' }}>Ladowanie...</div>
      ) : (
        <div style={{ backgroundColor: "var(--card-bg)", borderRadius: '6px', border: '1px solid var(--border)', overflow: 'hidden' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
            <thead>
              <tr style={{ backgroundColor: 'var(--bg)' }}>
                <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Data</th>
                <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Nazwa</th>
                <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Lokalizacja</th>
                <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Kategoria</th>
                <th style={{ padding: '10px', textAlign: 'right', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Brutto</th>
                <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Termin</th>
                <th style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Status</th>
                <th style={{ padding: '10px', textAlign: 'center', borderBottom: '1px solid var(--border)', fontWeight: 600 }}>Akcje</th>
              </tr>
            </thead>
            <tbody>
              {costs.map(cost => (
                <tr key={cost.id} style={{ borderBottom: '1px solid var(--border)', background: !cost.location_id ? 'var(--info-light)' : 'var(--card-bg)' }}>
                  <td style={{ padding: '10px' }}>{formatDate(cost.data_kosztu)}</td>
                  <td style={{ padding: '10px' }}>
                    <div style={{ fontWeight: 500 }}>{cost.nazwa}</div>
                    <div style={{ fontSize: '10px', color: 'var(--text-muted)' }}>
                      {cost.kontrahent && <span>{cost.kontrahent}{cost.kontrahent_nip ? ` · NIP ${cost.kontrahent_nip}` : ''}</span>}
                      {cost.cykliczny && <span style={{ marginLeft: cost.kontrahent ? '8px' : 0, color: 'var(--purple)' }}>{'🔄'} Cykliczny</span>}
                      {cost.zrodlo && cost.zrodlo !== 'reczny' && ZRODLA[cost.zrodlo] && (
                        <span data-testid="zrodlo" title={ZRODLA[cost.zrodlo].opis} style={{ marginLeft: '8px', fontWeight: 600, background: ZRODLA[cost.zrodlo].tlo, color: ZRODLA[cost.zrodlo].kolor, padding: '1px 6px', borderRadius: '10px' }}>
                          {ZRODLA[cost.zrodlo].etykieta}
                        </span>
                      )}
                    </div>
                  </td>
                  <td style={{ padding: '10px' }}>
                    {cost.location_id ? (
                      <span style={{ fontSize: '11px' }}>{'📍'} {cost.lokalizacja_nazwa || `Lok. ${cost.location_id}`}</span>
                    ) : (
                      <span style={{ fontSize: '10px', padding: '2px 6px', background: 'var(--info)', color: '#fff', borderRadius: '3px' }}>
                        {'🏢'} Cała firma (dzielony)
                      </span>
                    )}
                  </td>
                  <td style={{ padding: '10px' }}>
                    <span style={{ background: cost.kategoria_kolor || 'var(--text-muted)', color: '#fff' , padding: '2px 8px', borderRadius: '4px', fontSize: '10px' }}>
                      {cost.kategoria_nazwa}
                    </span>
                  </td>
                  <td style={{ padding: '10px', textAlign: 'right', fontWeight: 600 }}>{formatMoney(cost.kwota_brutto)}</td>
                  <td style={{ padding: '10px', whiteSpace: 'nowrap' }}>
                    {cost.termin_platnosci ? formatDate(cost.termin_platnosci) : <span style={{ color: 'var(--text-muted)' }}>—</span>}
                    {cost.przeterminowany && <div data-testid="przeterminowany" style={{ fontSize: '10px', fontWeight: 600, color: 'var(--danger)' }}>przeterminowany {cost.dni_po_terminie} dni</div>}
                    {(cost.forma_platnosci || cost.rachunek_nr) && (
                      <div data-testid="platnosc-ksef" title={cost.rachunek_nr ? `Rachunek z faktury: ${cost.rachunek_formatowany || formatujRachunek(cost.rachunek_nr)}` : undefined}
                        style={{ fontSize: '10px', color: 'var(--text-secondary)' }}>
                        {cost.forma_platnosci || 'forma nieznana'}{cost.rachunek_nr ? <span style={{ fontFamily: 'monospace' }}> · {skrocRachunek(cost.rachunek_nr)}</span> : ''}
                      </div>
                    )}
                  </td>
                  <td style={{ padding: '10px', textAlign: 'center' }}>
                    <span style={{
                      padding: '3px 8px', borderRadius: '10px', fontSize: '10px',
                      background: cost.status === 'zaplacony' ? 'var(--success-light)' : 'var(--warning-light)',
                      color: cost.status === 'zaplacony' ? 'var(--success)' : 'var(--warning)'
                    }}>
                      {cost.status === 'zaplacony' ? 'Zapłacony' : 'Do zapłaty'}
                    </span>
                  </td>
                  <td style={{ padding: '10px', textAlign: 'center' }}>
                    <ActionMenu actions={[
                      cost.status !== 'zaplacony' && { icon: '✓', label: 'Zapłać', color: 'var(--success)', onClick: () => handlePayCost(cost) },
                      { icon: '✏️', label: 'Edytuj', color: 'var(--info)', onClick: () => openEditCost(cost) },
                      { icon: '🗑️', label: 'Usuń', color: 'var(--danger)', onClick: () => handleDeleteCost(cost) },
                    ]} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {costs.length === 0 && (
            <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)' }}>
              <div style={{ fontSize: '32px', marginBottom: '10px' }}>{'📋'}</div>
              <div style={{ marginBottom: '8px' }}>Brak kosztów do wyświetlenia</div>
              <div style={{ fontSize: '11px' }}>
                Kliknij "Odśwież" lub "Dodaj koszt" aby dodać pierwszy koszt.<br/>
                <span style={{ color: 'var(--danger)' }}>Sprawdź konsolę (F12) jeśli występują błędy.</span>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Modal dodawania/edycji kosztu */}
      {showCostModal && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'var(--card-bg)', padding: '20px', borderRadius: '8px', width: '500px', maxHeight: '80vh', overflow: 'auto' }}>
            <h3 style={{ marginTop: 0, marginBottom: '15px', fontSize: '16px' }}>{editingCost ? 'Edytuj koszt' : 'Nowy koszt'}</h3>
            <form onSubmit={handleSaveCost}>
              <div style={{ marginBottom: '12px' }}>
                <label style={{ display: 'block', marginBottom: '4px', fontWeight: 500, fontSize: '12px' }}>Nazwa *</label>
                <input type="text" required value={costForm.nazwa} onChange={(e) => setCostForm({...costForm, nazwa: e.target.value})} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid var(--border)', fontSize: '12px' }} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '4px', fontWeight: 500, fontSize: '12px' }}>Kategoria *</label>
                  <select required value={costForm.category_id} onChange={(e) => setCostForm({...costForm, category_id: e.target.value})} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid var(--border)', fontSize: '12px' }}>
                    <option value="">Wybierz...</option>
                    {costCategories.map(c => <option key={c.id} value={c.id}>{c.nazwa}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '4px', fontWeight: 500, fontSize: '12px' }}>Lokalizacja</label>
                  <select value={costForm.location_id} onChange={(e) => setCostForm({...costForm, location_id: e.target.value})} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid var(--border)', fontSize: '12px' }}>
                    <option value="">Ogólny (firma)</option>
                    {locations.map(l => <option key={l.id} value={l.id}>{l.nazwa}</option>)}
                  </select>
                </div>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '12px', marginBottom: '12px' }}>
                <div>
                  <label style={{ display: 'block', marginBottom: '4px', fontWeight: 500, fontSize: '12px' }}>Kwota netto *</label>
                  <input type="number" step="0.01" required value={costForm.kwota_netto} onChange={(e) => setCostForm({...costForm, kwota_netto: e.target.value})} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid var(--border)', fontSize: '12px' }} />
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '4px', fontWeight: 500, fontSize: '12px' }}>VAT %</label>
                  <select value={costForm.stawka_vat} onChange={(e) => setCostForm({...costForm, stawka_vat: parseInt(e.target.value)})} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid var(--border)', fontSize: '12px' }}>
                    <option value={23}>23%</option>
                    <option value={8}>8%</option>
                    <option value={5}>5%</option>
                    <option value={0}>0%</option>
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', marginBottom: '4px', fontWeight: 500, fontSize: '12px' }}>Data *</label>
                  <input type="date" required value={costForm.data_kosztu} onChange={(e) => setCostForm({...costForm, data_kosztu: e.target.value})} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid var(--border)', fontSize: '12px' }} />
                </div>
              </div>
              <div style={{ marginBottom: '12px' }}>
                <label style={{ display: 'block', marginBottom: '4px', fontWeight: 500, fontSize: '12px' }}>Kontrahent</label>
                <input type="text" value={costForm.kontrahent} onChange={(e) => setCostForm({...costForm, kontrahent: e.target.value})} style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid var(--border)', fontSize: '12px' }} />
              </div>
              <div style={{ marginBottom: '15px', padding: '10px', background: 'var(--bg)', borderRadius: '4px' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '12px' }}>
                  <input type="checkbox" checked={costForm.cykliczny} onChange={(e) => setCostForm({...costForm, cykliczny: e.target.checked})} />
                  <span>Koszt cykliczny</span>
                </label>
                {costForm.cykliczny && (
                  <select value={costForm.cykl_typ} onChange={(e) => setCostForm({...costForm, cykl_typ: e.target.value})} style={{ marginTop: '8px', width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid var(--border)', fontSize: '12px' }}>
                    <option value="">Wybierz cykl...</option>
                    <option value="miesiac">Miesięcznie</option>
                    <option value="kwartal">Kwartalnie</option>
                    <option value="rok">Rocznie</option>
                  </select>
                )}
              </div>
              <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                <button type="button" onClick={closeCostModal} style={{ padding: '6px 12px', border: '1px solid var(--text-muted)', color: 'var(--text-muted)', fontSize: '12px' }}>Anuluj</button>
                <button type="submit" style={{ padding: '6px 12px', border: '1px solid var(--success)', color: 'var(--success)', fontSize: '12px' }}>{editingCost ? 'Zapisz zmiany' : 'Dodaj koszt'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
